import { Injectable } from '@angular/core' ;
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';

import { AuthorizationFrontendService } from '../services/authorizationfrontend.service' ;

@Injectable({
    providedIn: 'root'
})
export class AuthorizationModuleViewGuard  {

    constructor(private router: Router, private m_AuthorizationService: AuthorizationFrontendService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        const authorizationPrefix = typeof route.data['authorizationPrefix'] === 'string' ? route.data['authorizationPrefix'] : '';
        const authorization = authorizationPrefix + (route.url.length === 0 ? '' : route.url[0].path);
        const allowed = await this.m_AuthorizationService.checkCanActivate(state.url, authorization);
        if (!allowed) {
            return this.router.createUrlTree(['/not-allowed']);
        }
        return true;
    }
}
